"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicButton = exports.blockClass = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Link_1 = require("../../1-inline/Link");
const Ripple_1 = require("../../misc/Ripple");
const context_1 = require("../../styles/context");
exports.blockClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    fz: '14px',
    // cur: 'pointer',
    us: 'none',
    trs: 'background .12s ease-in 0s, opacity .12s ease-in 0s',
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    fls: 0,
    bdrad: '3px',
    bg: 'transparent',
    bd: 0,
    mr: 0,
    pd: 0,
    out: 0,
    ov: 'visible',
    '&:hover': {
        bxsh: 'none',
    },
    '&:active': {
        bxsh: 'none',
    },
});
const dynamicBlockClass = (0, nano_theme_1.drule)({});
const borderClass = (0, nano_theme_1.drule)({});
const handleDragStart = (e) => e.preventDefault();
const BasicButton = ({ to, border, skewed, fill, size = 24, width = size, height = size, round, rounder, roundest, bdradL, bdradR, title, positive, noOutline, transparent, onClick, children, compact, spacious, disabled, selected, display, className = '', ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const textCol = styles.g(0.2);
    const bgFactor = styles.light ? 1 : 1.1;
    if (display) {
        width = 'auto';
        height = 'auto';
        spacious = true;
    }
    const blockDynamic = dynamicBlockClass({
        col: textCol,
        bg: selected ? styles.col.accent(0, 'bg-2') : transparent || !fill ? 'transparent' : 'rgba(128,128,128,0.07)',
        '&:hover': {
            col: disabled ? void 0 : textCol,
            bg: disabled ? void 0 : 'rgba(128,128,128,0.13)',
            bdfl: disabled ? void 0 : 'saturate(150%) blur(4px)',
        },
        '&:active': {
            bg: disabled ? void 0 : 'rgba(128,128,128,0.22)',
            bdfl: disabled ? void 0 : 'saturate(150%)',
        },
    });
    const borderDynamic = border
        ? ' ' +
            borderClass({
                bd: `1px solid ${styles.g(0, 0.08 * bgFactor)}`,
            })
        : '';
    const style = {
        ...rest.style,
        height,
    };
    style.width = width;
    if (display) {
        style.font = 'inherit';
    }
    if (typeof width !== 'number') {
        if (spacious) {
            style.padding = display ? 16 : '8px 16px';
        }
        else {
            style.paddingLeft = compact ? 8 : 16;
            style.paddingRight = compact ? 8 : 16;
        }
    }
    if (round) {
        style.borderRadius = '50%';
    }
    else if (skewed) {
        style.borderRadius = '18% / 25%';
    }
    else if (rounder) {
        style.borderRadius = '6px';
    }
    else if (roundest) {
        style.borderRadius = '1em';
    }
    if (bdradL !== void 0) {
        style.borderTopLeftRadius = bdradL;
        style.borderBottomLeftRadius = bdradL;
    }
    if (bdradR !== void 0) {
        style.borderTopRightRadius = bdradR;
        style.borderBottomRightRadius = bdradR;
    }
    if (noOutline) {
        style.boxShadow = 'none';
    }
    if (disabled) {
        style.opacity = 0.6;
        style.pointerEvents = 'none';
        style.boxShadow = 'none';
        style.outline = 'none';
    }
    return (React.createElement(Ripple_1.Ripple, { ms: 1500, color: positive ? styles.col.get('success') : styles.g(0, 0.08), disabled: disabled },
        React.createElement(Link_1.Link, { ...rest, a: !!to, className: className + exports.blockClass + blockDynamic + borderDynamic, style: style, title: title, onClick: to ? undefined : onClick, onDragStart: handleDragStart, to: to, "data-testid": "BasicButton" }, children)));
};
exports.BasicButton = BasicButton;
exports.default = exports.BasicButton;
